import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const COLORS = ['#6366f1', '#22c55e', '#f59e0b', '#ef4444']

const DUMMY_DATA = [
  { name: 'On Track', value: 14 },
  { name: 'At Risk', value: 5 },
  { name: 'Delayed', value: 3 },
  { name: 'Completed', value: 8 },
]

export function ProjectStatusBreakdownWidget() {
  return (
    <Card className='h-full flex flex-col'>
      <CardHeader className='pb-2'>
        <CardTitle className='text-sm font-medium text-muted-foreground'>
          Project Status Breakdown
        </CardTitle>
      </CardHeader>
      <CardContent className='flex-1 min-h-0'>
        <ResponsiveContainer width='100%' height='100%'>
          <PieChart>
            <Pie
              data={DUMMY_DATA}
              cx='50%'
              cy='50%'
              innerRadius='55%'
              outerRadius='80%'
              paddingAngle={3}
              dataKey='value'
            >
              {DUMMY_DATA.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length] || '#6366f1'}
                />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                borderRadius: '10px',
                border: '1px solid hsl(var(--border))',
                boxShadow: '0 4px 12px hsl(var(--foreground) / 0.08)',
                backgroundColor: 'hsl(var(--card))',
                fontSize: '12px',
              }}
            />
            <Legend
              wrapperStyle={{ fontSize: '11px' }}
              formatter={(value: string) => (
                <span className='text-foreground'>{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
        <p className='text-xs text-muted-foreground mt-1'>
          Dummy data — live connection coming later
        </p>
      </CardContent>
    </Card>
  )
}
